import moment from 'moment';
import _ from 'lodash';

export const getNow = (format: string = 'YYYY-MM-DD', isSearch?: boolean) => {
  if (isSearch) {
    let currentDate = moment().format(format);
    return `${currentDate}-23:59:59`;
  } else {
    return moment().format(format);
  }
};

export const getDisplay = (date: string) => {
  return moment(date).format('YYYY/MM/DD HH:mm:ss');
};

export const format = (
  baseDate: Date | string,
  dateFormat: string = 'YYYY/MM/DD',
  isSearch?: boolean,
  isValidated: boolean = true
) => {
  let targetDate = moment(baseDate).format(dateFormat);

  // Invalid date対策
  const isValidDate = moment(targetDate).isValid();

  if (isValidDate && isSearch) {
    return `${targetDate}-23:59:59`;
  }

  if (isValidDate) {
    return targetDate;
  } else {
    if (isValidated) {
      targetDate = '';
    }

    return targetDate;
  }
};

export const validateFormat = (targetDate: string | Date, format?: string) => {
  let result;

  try {
    if (format) {
      result = moment(targetDate, format, true).isValid();
    } else {
      result = moment(targetDate).isValid();
    }
  } catch (error) {
    result = false;
  }

  // Invalid date対策
  return _.isBoolean(result) ? result : false;
};

/**
 * 入力した日付が対象の日付より大きいか判定する
 * @param inputDate 入力された日付
 * @param fromDate 比較対象の日付
 */
export const isAfterDate = (
  inputDate: Date | string,
  fromDate: Date | string
) => {
  return moment(inputDate).isSameOrAfter(fromDate);
};

/**
 * 入力した日付が対象の日付より小さいか判定する
 * @param inputDate 入力された日付
 * @param targetDate 比較対象の日付
 */
export const isBeforeDate = (
  inputDate: Date | string,
  targetDate: Date | string
) => {
  return moment(inputDate).isBefore(targetDate);
};

/**
 * 入力された年月の日数を返す
 */
export const getDaysInMonth = (
  options: {year?: number; month?: number} = {}
) => {
  // Momentに月を渡す場合、0始まりなので - 1で計算する
  const month = options.month ? options.month - 1 : options.month;

  return moment({year: options.year, month}).daysInMonth();
};

/**
 * 対象の日付が有効かどうかを確認する
 */
export const isValid = (target: Date | string) => {
  return moment(target).isValid();
};
